import {
  REMOVE_HABITAT_ANIMAL,
  SET_HABITAT,
  SET_HABITAT_LIKED,
  SET_HABITAT_PROPS,
  SET_HABITAT_STREAM_STARTED,
  SET_SELECTED_CAMERA,
  UNSET_HABITAT,
  UPDATE_AVAILABLE_CAMERAS,
  UPSERT_HABITAT_ANIMAL,
} from './types';

export const setHabitat = ({ habitat }) => ({
  type: SET_HABITAT,
  payload: {
    habitat: {
      ...habitat,
      selectedCamera: habitat?.cameras[0],
      streamKey: habitat?.cameras[0]?.channelSettings?.[0]?.streamKey,
      hostStreamKey: habitat.hostStreamKey,
    },
  },
});

export const setHabitatLiked = (isLiked) => ({
  type: SET_HABITAT_LIKED,
  payload: { isLiked },
});

export const unsetHabitat = () => ({ type: UNSET_HABITAT });

export const setHabitatProps = (payload) => ({
  type: SET_HABITAT_PROPS,
  payload,
});

export const setHabitatStreamStarted = (streamStarted) => ({
  type: SET_HABITAT_STREAM_STARTED,
  payload: { streamStarted },
});

export const setSelectedCamera = (camera) => ({
  type: SET_SELECTED_CAMERA,
  payload: { camera },
});

export const handleCameraUpdate = (availableCameras) => ({
  type: UPDATE_AVAILABLE_CAMERAS,
  payload: { availableCameras },
});

export const upsertHabitatAnimal = (animal) => ({
  type: UPSERT_HABITAT_ANIMAL,
  payload: { animal },
});

export const removeHabitatAnimal = (animalId) => ({
  type: REMOVE_HABITAT_ANIMAL,
  payload: { animalId },
});
